import './App.css';
import logo from './assets/logo.png'
import { IoLogoInstagram } from "react-icons/io";
import { FaLinkedinIn } from "react-icons/fa";
import content_lb from './assets/cont_lp.svg'
import { useState, useEffect } from 'react';
import content_ph from './assets/cont_ph.svg'

function App() {
  const [rowHeight, setRowHeight] = useState(10.66);
  const [Content,setContent] = useState(content_lb)
  
  useEffect(() => {
    const updateRowHeight = () => {
      if (window.innerWidth <= 480) {
        setRowHeight(8); // Smaller rows for mobile
        setContent(content_ph)
      } else if (window.innerWidth <= 768) {
        setRowHeight(9); // Medium rows for tablet
      } else {
        setRowHeight(10.66); // Default for desktop
      }
    };

    updateRowHeight();
    window.addEventListener('resize', updateRowHeight);
    return () => window.removeEventListener('resize', updateRowHeight);
  }, [window.innerWidth]);

  const rows = Math.ceil(100 / rowHeight);

  return (
    <div className="page">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>

      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className={`row ${i % 2 === 0 ? "right" : "left"}`}
          style={{ top: `${i * rowHeight}%`, height: `${rowHeight}%` }}
        />
      ))}

      <div className="content">
        {/* <h1>COMING SOON</h1>
        <p>A tiny <span className='sub_heading_angle'>tilt.</span> A whole new direction.</p> */}
        <img src={Content}/>
      </div>

      <div className="footer">
        <div>
          <a href="https://www.linkedin.com/company/halfdegree/" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn fontWeight={800}/>
          </a>
          <a href="https://www.instagram.com/halfdegree.club" target="_blank" rel="noopener noreferrer">
            <IoLogoInstagram fontWeight={800}/>
          </a>
        </div>
        <div>
        Defined by <span style={{fontWeight:'bold'}} >Half Degree</span> 
        </div>
      </div>

      <div className="rotator">
        <div className="side-image side-image_left"></div>
        <div className="blur-rect "></div>
        <div className="side-image side-image_right"></div>
      </div>
    </div>
  );
}

export default App;